import { LoadingSpinner } from "@newsela/angelou";
import { useStandardsSearchContext } from "@/search/Langston/StandardsSearchProvider";
import {
  buttonSpinnerCss,
  spinnerWrapperCss,
  wrapperContainerCss,
} from "./StandardsLoadingSpinner.styles";

interface StandardsLoadingSpinnerProps {
  children: React.ReactNode;
  waitForAPI?: boolean;
  apiFlag?: boolean;
  isButtonSpinner?: boolean;
}

export const StandardsLoadingSpinner = ({
  children,
  waitForAPI,
  apiFlag,
  isButtonSpinner,
}: StandardsLoadingSpinnerProps) => {
  const { isLoadingStandardsResults } = useStandardsSearchContext();
  return (
    <div css={wrapperContainerCss} data-testid="spinner-container">
      {children}
      {((!waitForAPI && isLoadingStandardsResults) ||
        (waitForAPI && apiFlag)) && (
        <div css={spinnerWrapperCss} data-testid="loading-spinner">
          <LoadingSpinner
            __cssFor={{ root: isButtonSpinner ? buttonSpinnerCss : {} }}
          />
        </div>
      )}
    </div>
  );
};
